<template>
  <dt class="flex gap-100 items-center paragraph-bold" data-testid="price-details-play">
    <slot />

    <span v-if="name === EXTRA_HIT && lines" class="paragraph-small-text">
      {{ $t('common.words.lines', lines) }}
    </span>

    <span
      v-if="numberOfPlays > 1"
      class="flex items-center justify-center paragraph-small-text rounded-s p-050 bg-secondary-secondary text-primary-primary"
    >
      {{ $t('pricelist.perplay.label', { amount: numberOfPlays }) }}
    </span>
  </dt>
</template>

<script lang="ts" setup>
import { NUMBER_LOTTERY_PER_PLAY_ADD_ON_NAME } from '../constants/numberLottery'

const EXTRA_HIT = NUMBER_LOTTERY_PER_PLAY_ADD_ON_NAME.ExtraHit

type Props = {
  lines?: Maybe<number>
  name?: Maybe<string>
  numberOfPlays: number
}

defineProps<Props>()
</script>
